<template>
  <div class="tw-max-w-7xl tw-mx-auto tw-relative">
    <img :src="currentSceneBg" alt="banner" class="tw-w-full tw-hidden md:tw-block">
    <img :src="currentSceneMobile" alt="banner" class="tw-w-full md:tw-hidden">

    <div class="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-end tw-p-4 md:tw-p-16">

      <div class="tw-grid tw-grid-cols-3 tw-gap-8">
        <div v-for="(data, scene) in scenes"
             @click="active = scene"
             :class="[active === scene ? 'tw-bg-white/40' : 'tw-bg-white/0']"
             class="tw-aspect-square tw-p-4 md:tw-p-8 tw-rounded-full tw-transition-all tw-ease-in-out tw-duration-300 hover:tw-bg-white/40 tw-cursor-pointer">
          <img :src="data.thumb" alt="thumb1" class="tw-w-full tw-pointer-events-none">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AssetLoader from "../../../AssetLoader";
import DiversityLensLine from "./DiversityLensLine.vue";
import BreakpointBar from "./BreakpointBar.vue";

export default {
  components: {BreakpointBar, DiversityLensLine},
  data() {
    return {
      active: 'relatable'
    }
  },
  computed: {
    images() {
      return {
        bg1: AssetLoader.imagePath('div_lens/inclusive-img1.jpg'),
        bg2: AssetLoader.imagePath('div_lens/inclusive-img2.jpg'),
        bg3: AssetLoader.imagePath('div_lens/inclusive-img3.jpg'),
        mobileBg1: AssetLoader.imagePath('div_lens/inclusive-mobile-img1.jpg'),
        mobileBg2: AssetLoader.imagePath('div_lens/inclusive-mobile-img2.jpg'),
        mobileBg3: AssetLoader.imagePath('div_lens/inclusive-mobile-img3.jpg'),
        thumb1: AssetLoader.imagePath('div_lens/relatable-img1.png'),
        thumb2: AssetLoader.imagePath('div_lens/relatable-img2.png'),
        thumb3: AssetLoader.imagePath('div_lens/relatable-img3.png'),
      }
    },

    btnImages() {
      return [this.images.thumb1, this.images.thumb2, this.images.thumb3]
    },

    scenes() {
      return {
        relatable: {
          bg: this.images.bg1,
          thumb: this.images.thumb1,
          mobile: this.images.mobileBg1
        },
        scene2: {
          bg: this.images.bg2,
          thumb: this.images.thumb2,
          mobile: this.images.mobileBg2
        },
        scene3: {
          bg: this.images.bg3,
          thumb: this.images.thumb3,
          mobile: this.images.mobileBg3
        },
      }
    },

    currentSceneBg() {
      return this.scenes[this.active].bg
    },

    currentSceneMobile() {
      return this.scenes[this.active].mobile
    }
  }
}
</script>
